import React, { useRef, useState } from 'react';
import clsx from 'clsx';

interface DragDropProps {
	onFileSelect: (file: File) => void
	filetype?: string,
	className?: string
	children?: React.ReactNode,
}

export const DragDrop = ({
	onFileSelect,
	filetype,
	className,
	children,
}: DragDropProps) => {
	const [fileIsDraggedOver, setFileIsDraggedOver] = useState(false);
	const fileInputRef = useRef<HTMLInputElement>(null);
	return (
		<div
			role="button"
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault(); // Prevent scrolling on spacebar
					fileInputRef.current?.click();
				}
			}}
			onClick={() => fileInputRef.current?.click()}
			onDragEnter={(e) => {}}
			onDragOver={(e) => {
				e.preventDefault();
				setFileIsDraggedOver(true);
			}}
			onDragLeave={() => setFileIsDraggedOver(false)}
			onDrop={(e) => {
				e.preventDefault();
				const file = [...e.dataTransfer.items || []].map((i) => i?.getAsFile?.())?.find((f) => f);
				if (file) {
					onFileSelect(file);
				}
			}}
			className={clsx(
				'border-2 border-dashed border-borders-primary rounded-lg',
				'hover:border-borders-primary_hover hover:shadow-[0px 4px 7px 2px rgba(25, 25, 25, 0.05)]',
				'active:border-borders-primary_pressed',
				fileIsDraggedOver && 'border-borders-primary_pressed',
				className,
			)}
		>
			<input
				type="file"
				ref={fileInputRef}
				{...(filetype && { accept: filetype })}
				className="hidden"
				onChange={(e) => {
					const file = e.target.files?.[0];
					if (file) onFileSelect(file);
				}}
			/>
			{children}
		</div>
	);
};
